import RequestAccess from './RequestAccess';
//It looks like this is replaced by request-accessnew
export default RequestAccess;
